import axios from 'axios'
import store from "@/store";
import router from "@/router";

let axiosMain = axios.create();
axiosMain.headers = {
  source:'WEB',
};
axiosMain.interceptors.request.use(config => {
  if(config.url){
    let hasUrlApi = /^\/api/.test(config.url);
    let hasUrlErp = /^\/erp/.test(config.url)
    if(/^\/(pre)/.test(config.url)){

    }else if (hasUrlErp) {
      config.url = config.url.replace(/^\/erp/, '')
    } else {
      if(!hasUrlApi) config.url = '/api' + config.url;
    }
  }
  console.log(config.url)
  if(!(/\/jiuyu-erp/ig.test(config.baseURL) || /\/erp/ig.test(config.baseURL))){
    if (localStorage.getItem("Authorization_lineSupplier")) {
      const token = JSON.parse(localStorage.getItem("Authorization_lineSupplier")).token;
      token ? config.headers.token = token : null;
    }
  }
  return config
});
axiosMain.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      if (error.response.status == '401') {
        confirm('登录已过期,请重新登录')
        localStorage.clear();
        store.state.Authorization = null
        sessionStorage.removeItem("Authorization_lineSupplier")
        router.replace({
          path: '/'
        })
      }
    }
    return Promise.reject(error.response.data)
  })

export default axiosMain;



// WEBPACK FOOTER //
// ./src/axios/index.js